module.exports = __webpack_public_path__ + "img/lineas.68692bae.svg";